import { useTranslation } from 'react-i18next';

import type { BookingEventWaveDetail } from '@/types';

import { cn } from '@/lib/utils';

import { bookingTimeRange } from '@/helpers';

import { ALL_WAVES } from './utils';
import { WaveTile } from './WaveTile';

type WavePickerProps = {
  waves: BookingEventWaveDetail[];
  selectedWaveId: number | null;
  onWaveSelect: (waveId: number | null) => void;
};

export const WavePicker = (props: WavePickerProps) => {
  const { waves, selectedWaveId, onWaveSelect } = props;
  const { t } = useTranslation();

  return (
    <div className="grid gap-2">
      <p className="text-sm font-medium">{t('Waves')}</p>

      <div className="flex flex-wrap gap-2">
        <button
          type="button"
          onClick={() => onWaveSelect(ALL_WAVES)}
          className={cn(
            'rounded-md border px-3 py-2 text-left text-sm',
            selectedWaveId === ALL_WAVES && 'border-primary bg-muted',
          )}
        >
          {t('All waves')}
        </button>

        {waves.map((wave) => (
          <WaveTile
            key={wave.id}
            wave={wave}
            period={bookingTimeRange(wave.starts_at, wave.ends_at)}
            isSelected={selectedWaveId === wave.id}
            onWaveSelect={() => onWaveSelect(wave.id)}
          />
        ))}
      </div>
    </div>
  );
};
